export const apiUrl = "https://api.mymindzen.com";
export const s3Url = "https://mindzen-bucket.s3.us-east-2.amazonaws.com";
const toS3PublicUrl = (url) => {
  if (url == null) return undefined;
  const path = String(url).trim();
  if (!path || path === "undefined" || path === "null") return undefined;
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  return `${s3Url}/${path}`;
};

export const imageUrl = (url) => toS3PublicUrl(url);
export const mediaUrl = (url) => toS3PublicUrl(url);

export const BaseURL = (link) => {
  return `${apiUrl}/api/v1/${link}`;
};
